import { Reveal } from "@/components/Reveal";
import RelicCard from "@/components/RelicCard";
import { useProducts } from "@/hooks/useProducts";

export default function Collection() {
  const { products, loading } = useProducts();

  return (
    <div className="pt-32 md:pt-40 pb-24" data-testid="collection-page">
      <div className="container-lux">
        <Reveal>
          <p className="label-mono mb-6 text-blood">The Collection</p>
          <h1 className="heading-serif text-5xl md:text-7xl mb-8 leading-[0.95]">
            Beautiful Fears
          </h1>
          <p className="max-w-xl text-base md:text-lg text-ivory/75 font-sans leading-relaxed">
            Each fragrance is an Eau de Parfum housed in a sculptural flacon, made in small numbers.
            Childhood dread, reimagined as something you will want to wear.
          </p>
        </Reveal>

        {loading ? (
          <p className="label-mono text-smoke py-20 mt-10">Opening the collection…</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16 mt-16">
            {products.map((p, i) => (
              <RelicCard key={p.slug} product={p} index={i} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
